module.exports = __webpack_public_path__ + "img/FMOH-Logo.99af9f5c.png";